import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-loader',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './page-loader.component.html',
  styleUrl: './page-loader.component.scss'
})
export class PageLoaderComponent {
  // loader text
  @Input() text = '';
  // loader flag
  @Input() loading = false;
}
